import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { bindActionCreators } from 'redux'

import Tour from 'components/Tour'
import Content, { IGameInfo } from './content'

import {
  completedGameClick,
  notCompletedGameClick,
  notGameClick
} from 'data/games/messages'

import GameType from 'data/games/gameTypes'
import { getFaultGames, getGameInfo } from 'services/games'
import * as PatientActions from 'store/patients/actions'

import { getCurrentAssessment } from 'services/patient'
import SnackbarService from 'services/snackbars'
import * as UserActions from 'store/user/actions'

import { TChildListener } from 'components/ChildListener/context'
import { _route } from 'routes/config'

interface INativeProps {
  childListener: TChildListener
}

interface IReduxStateProps {
  currentPatient: any
  user: any
  plusUser: any
}

interface IReduxDispatchProps {
  PatientsLib: any
  UserLib: any
}

interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}

interface IProps extends INativeProps, IReduxProps, RouteComponentProps {}

interface IState {
  faultGames: GameType[]
  loading: boolean
  instructionFaultGames: GameType[]
  isOpenPlusOnlyPopup: boolean
}

class EvaluationGames extends React.Component<IProps, IState> {
  state: IState = {
    faultGames: [],
    loading: true,
    instructionFaultGames: [],
    isOpenPlusOnlyPopup: false
  }

  openPlusOnlyPopup = () => {
    this.setState({ isOpenPlusOnlyPopup: true })
  }

  closePlusOnlyPopup = () => {
    this.setState({ isOpenPlusOnlyPopup: false })
  }

  getGameInfo = (type: GameType): Partial<IGameInfo> => {
    const baseInfo = getGameInfo(this.props.currentPatient, type)
    if (!baseInfo) {
      return {}
    }
    const message = !baseInfo.isGame
      ? notGameClick
      : baseInfo.completed < baseInfo.fullCount
      ? notCompletedGameClick
      : completedGameClick
    const onClick = () => SnackbarService.showSnackbar(message, 'info')

    return {
      ...baseInfo,
      onClick
    }
  }

  getGamesInfo = (): IGameInfo[] => {
    return [
      {
        type: GameType.math,
        ...this.getGameInfo(GameType.math)
      },
      {
        type: GameType.attention,
        ...this.getGameInfo(GameType.attention)
      },
      {
        type: GameType.memory,
        ...this.getGameInfo(GameType.memory)
      },
      {
        type: GameType.spatial,
        ...this.getGameInfo(GameType.spatial)
      },
      {
        type: GameType.executiveFunctions,
        ...this.getGameInfo(GameType.executiveFunctions)
      }
    ]
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    // don't show currentPatient data from localstorage if user just pasted link for user and localstorage isn't clean because on turn onn listener it will make the request
    if (this.props.currentPatient && this.props.childListener) {
      this.setFaultGames()
      this.setInstructionFaultGames()
    }
  }

  componentDidUpdate(prevProps) {
    const { currentPatient } = this.props
    const { currentPatient: prevCurrentPatient } = prevProps

    if (currentPatient && currentPatient !== prevCurrentPatient) {
      this.setFaultGames()
      this.setInstructionFaultGames()
    }
  }

  setFaultGames = () => {
    const assessment = getCurrentAssessment(this.props.currentPatient)

    if (assessment) {
      const faultGames = getFaultGames(assessment.accuracy_fault_games)
      this.setState({ faultGames })
    }

    this.setState({ loading: false })
  }

  setInstructionFaultGames = () => {
    const assessment = getCurrentAssessment(this.props.currentPatient)

    if (assessment) {
      const instructionFaultGames = getFaultGames(
        assessment.instruction_fault_games
      )
      this.setState({ instructionFaultGames })
    }

    this.setState({ loading: false })
  }

  goBackAction = () => {
    this.props.history.push(_route.child.list)
  }

  render() {
    const {
      currentPatient,
      user: { role },
      history,
      user,
      plusUser
    } = this.props
    const {
      faultGames,
      loading,
      instructionFaultGames,
      isOpenPlusOnlyPopup
    } = this.state

    return (
      <>
        {!loading && <Tour userId={user.userId} />}
        <Content
          faultGames={faultGames}
          patientId={currentPatient?.patientId}
          patientDetail={currentPatient}
          games={this.getGamesInfo()}
          role={role}
          user={user}
          history={history}
          goBackAction={this.goBackAction}
          loading={loading}
          instructionFaultGames={instructionFaultGames}
          plusUser={plusUser}
          openPlusOnlyPopup={this.openPlusOnlyPopup}
          isOpenPlusOnlyPopup={isOpenPlusOnlyPopup}
          closePlusOnlyPopup={this.closePlusOnlyPopup}
        />
      </>
    )
  }
}

const mapStateToProps = (state): IReduxStateProps => ({
  currentPatient: state.patients.currentPatient,
  user: state.user.data,
  plusUser: state.plus_user.isPlusUser
})

const mapDispatchToProps = (dispatch): IReduxDispatchProps => ({
  UserLib: bindActionCreators<any, any>(UserActions, dispatch),
  PatientsLib: bindActionCreators(PatientActions, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationGames)



// WEBPACK FOOTER //
// ./src/pages/EvaluationGames/index.tsx